import React, { useState } from 'react';
import { ReactComponent as Icon } from 'assets/icons/shareBtn.svg';
import styled from 'styled-components/macro';
import { Button } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import ModalWithTitle from 'components/Modal/ModalWIthTitle';
import { LinkList } from './LinksList/LinkList';

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  border-color: #e6e6e5;
`;

const ShareIcon = styled(Icon)`
  width: 16px;
  fill: ${({ theme }) => theme.colors.primary};
  margin-right: 0.5rem;
  color: ${({ theme }) => theme.colors.primary};
`;

interface Props {
  organization: any;
  surveyId: string;
}

export const ReportSharing = ({ organization, surveyId }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const t = useFormatMessage();

  return (
    <div>
      <StyledButton onClick={() => setIsOpen(true)} variant="outlined">
        <ShareIcon /> {t('project.share.shareReport.share', 'Share')}
      </StyledButton>
      <ModalWithTitle
        open={isOpen}
        title={t('project.share.shareReport', 'Share report')}
        onClose={() => setIsOpen(false)}
      >
        {isOpen && (
          <LinkList
            surveyId={surveyId}
            organization={organization}
            closeModal={() => setIsOpen(false)}
          />
        )}
      </ModalWithTitle>
    </div>
  );
};
